export const workshopName = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
